import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { Specimen } from "pwapi";

import { deleteSpecimen } from "shared/actions/admin/adminSpecimenActions";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import WarningDialog from "../WarningDialog";

type SpecimenWarningDialogProps = {
  case_id: number;
  specimen: Specimen;
  delStatus?: "loading" | "success";
  errorMessage?: string;
  resetErrorMessage: Function;
  onClose: Function;
};

const SpecimenWarningDialog = ({
  case_id,
  specimen,
  delStatus,
  errorMessage,
  resetErrorMessage,
  onClose,
}: SpecimenWarningDialogProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      resetErrorMessage();
    };
  }, []);

  const onDeleteSpecimen = (specimen: Specimen) => {
    dispatch(
      deleteSpecimen({
        specimen_id: specimen.id!,
        case_id: case_id,
      })
    );
  };

  return (
    <WarningDialog
      onClose={() => onClose()}
      dialogStatus={delStatus}
      title={`Delete Specimen ${specimen.name}`}
    >
      <div className="CaseWarningDialog">
        <span>Would you like to delete this specimen?</span>
        {errorMessage && <p className="errorMessage">{errorMessage}</p>}
        <div className="actions__container">
          <PathologyWatchButton onClick={() => onClose()}>
            Cancel
          </PathologyWatchButton>
          <PathologyWatchButton
            type="submit"
            color="red"
            onClick={() => {
              onDeleteSpecimen(specimen);
            }}
          >
            Delete
          </PathologyWatchButton>
        </div>
      </div>
    </WarningDialog>
  );
};

export default SpecimenWarningDialog;
